import { formatISO } from 'date-fns';
import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { ALL_MODELS, ALL_MODELS_RUNE } from './constants';
import {
  AllModalsSuccess,
  AllModalsError,
  AllModalsDataActionTypes,
  AllModalsState,
  AllModalsRun,
} from './types';

const initialState: AllModalsState = {
  status: idle,
  entities: {
    items: [],
    cnt_all: null,
    cnt: null,
    pages: null,
  },
  error: null,
};

export default produce(
  (
    draft: AllModalsState = initialState,
    action: AllModalsDataActionTypes,
  ): AllModalsState => {
    switch (action.type) {
      case ALL_MODELS + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case ALL_MODELS + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as AllModalsSuccess).payload;
        break;
      }
      case ALL_MODELS + FAILURE: {
        draft.status = rejected;
        draft.error = (action as AllModalsError).error;
        break;
      }
      case ALL_MODELS_RUNE: {
        const newPayload = (action as AllModalsRun).payload;
        draft.entities.items = draft.entities.items.map((item) => {
          if (item.id === newPayload) {
            item.last_run_at = formatISO(new Date());
          }
          return item;
        });
        break;
      }
      default:
        return draft;
    }
  },
);
